import React, { useState } from 'react'

import { Icon, Input } from 'antd'
import get from 'lodash/get'
import styled from 'styled-components'

const SInput = styled(/** @type {any} */ (Input))`
  .ant-form-item-control-wrapper {
    margin-top: 32px !important;
  }
`

const SPasswordInput = styled(/** @type {any} */ (Input))`
  .ant-form-item-control-wrapper {
    margin-top: 32px !important;
  }
`

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  line-height: 1;
  padding: 0;
`

const SingleLineTextInput = React.forwardRef((/** @type {any} */ props, ref) => {
  const [visible, setVisible] = useState(false)
  const extraProps = {}
  const inputType = get(props, 'inputType', '')

  if (get(props, 'icon')) {
    extraProps.prefix = (
      <Icon type={get(props, 'icon')} aria-hidden style={{ color: 'rgba(0, 0, 0, 0.25)' }} />
    )
  }

  if (inputType === 'password') {
    return (
      <SPasswordInput
        ref={ref}
        {...props}
        {...props.input}
        type={visible ? 'text' : 'password'}
        allowClear={false}
        suffix={
          <ToggleButton
            type="button"
            aria-label={visible ? 'Hide password' : 'Show password'}
            onClick={() => setVisible(v => !v)}
          >
            <Icon type={visible ? 'eye' : 'eye-invisible'} aria-hidden />
          </ToggleButton>
        }
      />
    )
  }

  return <SInput ref={ref} {...props} {...extraProps} {...props.input} />
})

export default SingleLineTextInput
